import {
  type ChallengeSummary,
  type SetComplexImmerStateAction,
  type TaskSummary,
} from '@/lib/types';
import { createContext } from 'react';
import dummyFunction from '@/lib/utils/dummyFunction';

export type PortfolioItemSummaryWithThumbnail = (
  ChallengeSummary | TaskSummary
) & {
  thumbnail:
    | NonNullable<ChallengeSummary['thumbnail']>
    | NonNullable<TaskSummary['thumbnail']>;
};

const PortfolioItemCardThumbnailContext = createContext<{
  portfolioItemSummary: PortfolioItemSummaryWithThumbnail;
  setPortfolioItemSummary: SetComplexImmerStateAction<
    ChallengeSummary | TaskSummary
  >;
  portfolioItemApiEndpoint: string;
}>({
  portfolioItemSummary: null as unknown as PortfolioItemSummaryWithThumbnail,
  setPortfolioItemSummary: dummyFunction,
  portfolioItemApiEndpoint: '',
});

export default PortfolioItemCardThumbnailContext;
